var DialogTheme = {};

DialogTheme.defaultBlockStyles = {
  "story_blocks": {
    "colourPrimary": "#FB6107",
    "colourSecondary": "#C94C03",
    "colourTertiary": "#FC7F36"
  },
  "interactivity_blocks": {
    "colourPrimary": "#7CB518",
    "colourSecondary": "#6FA215",
    "colourTertiary": "#9EE326"
  },
  "colour_blocks": {
    "colourPrimary": "#CF63CF",
    "colourSecondary": "#C94FC9",
    "colourTertiary": "#BD42BD"
  },
  "list_blocks": {
    "colourPrimary": "#9966FF",
    "colourSecondary": "#855CD6",
    "colourTertiary": "#774DCB"
  },
  "logic_blocks": {
    "colourPrimary": "#4C97FF",
    "colourSecondary": "#4280D7",
    "colourTertiary": "#3373CC"
  },
  "loop_blocks": {
    "colourPrimary": "#ff0f64",
    "colourSecondary": "#ff0f64",
    "colourTertiary": "#ff0f64"
  },
  "math_blocks": {
    "colourPrimary": "#ff5a0f",
    "colourSecondary": "#ff5a0f",
    "colourTertiary": "#ff5a0f"
  },
  "procedure_blocks": {
    "colourPrimary": "#008c5a",
    "colourSecondary": "#008c5a",
    "colourTertiary": "#008c5a"
  },
  "text_blocks": {
    "colourPrimary": "#41b9e6",
    "colourSecondary": "#41b9e6",
    "colourTertiary": "#41b9e6"
  },
  "variable_blocks": {
    "colourPrimary": "#FF8C1A",
    "colourSecondary": "#FF8000",
    "colourTertiary": "#DB6E00"
  },
  "variable_dynamic_blocks": {
    "colourPrimary": "#FF8C1A",
    "colourSecondary": "#FF8000",
    "colourTertiary": "#DB6E00"
  },
  "hat_blocks": {
    "colourPrimary": "#4C97FF",
    "colourSecondary": "#4280D7",
    "colourTertiary": "#3373CC"
  }
};

DialogTheme.categoryStyles = {
  "colour_category": {
    "colour": "#CF63CF"
  },
  "list_category": {
    "colour": "#9966FF"
  },
  "logic_category": {
    "colour": "#4C97FF"
  },
  "loop_category": {
    "colour": "#0fBD8C"
  },
  "math_category": {
    "colour": "#59C059"
  },
  "procedure_category": {
    "colour": "#FF6680"
  },
  "text_category": {
    "colour": "#FFBF00"
  },
  "variable_category": {
    "colour": "#FF8C1A"
  },
  "variable_dynamic_category": {
    "colour": "#FF8C1A"
  }
};


export {
  DialogTheme
}
